import { FC } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import { Card } from '@savgroup-front-common/core/atoms/Cards';
import { H2 } from '@savgroup-front-common/core/atoms/headings';
import { Paragraph } from '@savgroup-front-common/core/atoms/Paragraph';
import {
  customComponentDecorator,
  Linkify,
} from '@savgroup-front-common/core/components/Linkify';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { MessageType } from '@savgroup-front-common/types';

import messages from './messages';

interface CustomerCommentDisplayProps {
  action?: {
    toCustomerComment?: string;
  };
  title?: MessageType;
}

const CustomerCommentDisplay: FC<CustomerCommentDisplayProps> = ({
  action,
  title = messages.sellerComment,
}) => {
  const toCustomerComment = action?.toCustomerComment;

  if (!toCustomerComment) {
    return null;
  }

  return (
    <Card>
      <Row data-testid="customer-block">
        <Col xs={12}>
          <H2>
            <SafeFormattedMessageWithoutSpread message={title} />
          </H2>
          <Paragraph />
        </Col>
        <Col xs={12}>
          <Linkify componentDecorator={customComponentDecorator}>
            {toCustomerComment}
          </Linkify>
        </Col>
      </Row>
    </Card>
  );
};

CustomerCommentDisplay.displayName = 'CustomerCommentDisplay';

export default CustomerCommentDisplay;
